import { useEffect } from "react"

interface ThemeColors {
  light: string
  dark: string
  threshold?: number
}

export function useMobileThemeColor({ light, dark, threshold = 80 }: ThemeColors) {
  useEffect(() => {
    const metaTheme = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null
    if (!metaTheme) return

    function updateThemeColor() {
      const scrollY = window.scrollY || window.pageYOffset
      const colour = scrollY < threshold ? light : dark
      if (metaTheme && metaTheme.content !== colour) metaTheme.setAttribute("content", colour)
    }

    updateThemeColor()
    window.addEventListener("scroll", updateThemeColor, { passive: true })
    return () => window.removeEventListener("scroll", updateThemeColor)
  }, [light, dark, threshold])
}
